import React from 'react'

export type RouterMatchContextProps = {
  params: any,
}

export const RouterMatchContext = React.createContext<RouterMatchContextProps>({
  params: undefined,
})
